var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { createId } from './utils/itemIdUtils';
import { isItemExpandedAndWithChildren, hasChildren } from './utils/itemUtils';
import { Reveal } from '@progress/kendo-react-animation';
/**
 * @hidden
 */
var TreeViewItem = /** @class */ (function (_super) {
    __extends(TreeViewItem, _super);
    function TreeViewItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreeViewItem.prototype.render = function () {
        var _this = this;
        var subitems = this.renderSubitemsIfApplicable();
        return (React.createElement("li", { className: this.getRootClassName(), tabIndex: this.tabIndex, role: "treeitem", "aria-expanded": this.ariaExpanded, "aria-selected": this.ariaSelected, "aria-disabled": this.fieldsSvc.disabled(this.item) ? true : undefined, ref: function (el) { return _this.itemElement = el; } },
            React.createElement("div", { className: "k-mid" },
                this.renderIcon(),
                React.createElement("span", { className: this.getContentClassName(), onClick: function (e) { return _this.props.onItemClick(e, _this.itemId); } }, this.props.itemRender ?
                    React.createElement(this.props.itemRender, { item: this.item, itemHierarchicalIndex: this.itemId }) :
                    this.fieldsSvc.text(this.item))),
            this.props.animate ?
                React.createElement(Reveal, { transitionEnterDuration: 200, transitionExitDuration: 200, style: { display: 'block' }, children: subitems }) : subitems));
    };
    TreeViewItem.prototype.componentDidMount = function () {
        var focusedItemId = this.props.focusedItemId;
        var currentItemId = this.itemId;
        if (focusedItemId && focusedItemId === currentItemId) {
            this.itemElement.focus();
        }
    };
    TreeViewItem.prototype.componentDidUpdate = function (prevProps) {
        var focusedItemId = this.props.focusedItemId;
        if (focusedItemId &&
            focusedItemId !== prevProps.focusedItemId &&
            focusedItemId === this.itemId) {
            this.itemElement.focus();
        }
    };
    TreeViewItem.prototype.renderIcon = function () {
        // If it is explicitly said that the item has children (even not loaded yet)
        // or if the item actually has children, then render the icon.
        var _this = this;
        return this.fieldsSvc.hasChildren(this.item) || hasChildren(this.item) ?
            React.createElement("span", { className: this.getIconClassName(), onClick: function (e) { return _this.props.onExpandChange(e, _this.itemId); } }) :
            undefined;
    };
    TreeViewItem.prototype.renderSubitemsIfApplicable = function () {
        var _this = this;
        return isItemExpandedAndWithChildren(this.item, this.fieldsSvc) ?
            (React.createElement("ul", { className: "k-content", role: "group" }, this.item.items.map(function (item, index) {
                return React.createElement(TreeViewItem, { item: item, animate: _this.props.animate, itemId: createId(index, _this.itemId), focusedItemId: _this.props.focusedItemId, tabbableItemId: _this.props.tabbableItemId, fieldsService: _this.props.fieldsService, itemRender: _this.props.itemRender, ariaMultiSelectable: _this.props.ariaMultiSelectable, onItemClick: _this.props.onItemClick, onExpandChange: _this.props.onExpandChange, key: index });
            }))) : undefined;
    };
    Object.defineProperty(TreeViewItem.prototype, "fieldsSvc", {
        get: function () {
            return this.props.fieldsService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeViewItem.prototype, "itemId", {
        get: function () {
            return this.props.itemId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeViewItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeViewItem.prototype, "tabIndex", {
        get: function () {
            return (this.props.focusedItemId || this.props.tabbableItemId) === this.itemId ? 0 : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeViewItem.prototype, "ariaExpanded", {
        get: function () {
            return this.fieldsSvc.hasChildren(this.item) || hasChildren(this.item) ?
                Boolean(this.fieldsSvc.expanded(this.item)) : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeViewItem.prototype, "ariaSelected", {
        get: function () {
            if (this.fieldsSvc.selected(this.item)) {
                return true;
            }
            else if (this.props.ariaMultiSelectable) {
                return this.fieldsSvc.disabled(this.item) ? undefined : false;
            }
            else {
                return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    TreeViewItem.prototype.getIconClassName = function () {
        return classNames('k-icon', {
            'k-i-expand': !this.fieldsSvc.expanded(this.item),
            'k-i-collapse': this.fieldsSvc.expanded(this.item),
            'k-i-loading': this.fieldsSvc.expanded(this.item) && !hasChildren(this.item)
        });
    };
    TreeViewItem.prototype.getRootClassName = function () {
        return classNames('k-item k-treeview-item', { 'k-state-disabled': this.fieldsSvc.disabled(this.item) });
    };
    TreeViewItem.prototype.getContentClassName = function () {
        return classNames('k-in', {
            'k-state-focused': this.props.focusedItemId === this.itemId,
            'k-state-selected': this.fieldsSvc.selected(this.item)
        });
    };
    return TreeViewItem;
}(React.Component));
export default TreeViewItem;
//# sourceMappingURL=TreeViewItem.js.map